import { NextPageContext } from 'next'
import Router from 'next/router'
import isMobile from 'is-mobile'
import getLiveUrl from './get-live-url'

export interface IRedirectToParams {
  ctx: NextPageContext
  status: number
  url: string
}

export interface IRedirectInfoParams {
  ctx: NextPageContext
  gid: string
  webRid?: string
  articleType: number
  isVisible?: boolean
  isLive?: boolean
}

export type TRedirectInfo =
  | { status: 404 }
  | { status: 200 }
  | { status: 301; url: string }
  | { status: 302; url: string }

/** 重定向到指定地址 */
export const redirectTo = ({ ctx, status, url }: IRedirectToParams) => {
  const { res } = ctx
  if (res) {
    res.writeHead(status || 302, { Location: url })
    res.end()
  } else if (url[0] === '/' && url[1] !== '/') {
    Router.push(url)
  } else if (typeof window !== 'undefined') {
    window.location.href = url
  }
}

/** 获取 pgc 和 ugc 之间的重定向信息 */
export const getRedirectInfo = ({
  ctx,
  gid,
  webRid,
  articleType,
  isVisible = true,
  isLive = false,
}: IRedirectInfoParams): TRedirectInfo => {
  // (1) 直播
  if (isLive) {
    return {
      status: 301,
      url: getLiveUrl(gid, webRid),
    }
  }

  // (2) 文章不可见或者被删除
  if (!isVisible || !articleType) {
    return {
      status: 404,
    }
  }

  // (3) 路径数据
  const regExp =
    /\/(koubei|article|video|ugc\/article)\/(\d+)(?:-(\d+))?(?:\?.+)?/
  const [, path] = ctx.asPath?.match(regExp) || []
  const isKoubei = [12, 13, 14].includes(articleType)
  const isPgcArticle = [1, 3, 4].includes(articleType)
  const isPgcVideo = articleType === 2
  const redirectPath = isKoubei
    ? '/koubei' // ugc 新老口碑
    : isPgcArticle
    ? '/article' // pgc 文章
    : isPgcVideo
    ? '/video' // pgc 视频
    : '/ugc/article' // ugc 文章视频
  const isSamePath = redirectPath === `/${path}`
  const isM = isMobile({
    ua: ctx.req?.headers['user-agent'],
  })

  // (4) 当前项目为 PC 站，所以移动端需重定向到 M 站
  if (isM) {
    return {
      status: 302,
      url: `https://m.dongchedi.com${redirectPath}/${gid}`,
    }
  }

  // (5) 重定向路径和原本的一致，则无需重定向
  if (isSamePath) {
    return {
      status: 200,
    }
  }

  // (6) 需要重定向
  return {
    status: 301,
    url: `${redirectPath}/${gid}`,
  }
}
